import { type MailboxInfo, getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { BizChatCompositeKey, WindowKey } from 'owa-bizchat-types';

/**
 * TODO transition this to being more generically named, since this is just a generic composite key
 */
export const getBizchatLoadedKey = (
    mailboxInfo: MailboxInfo,
    windowKey: WindowKey
): BizChatCompositeKey => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return `${accountKey}_${windowKey}`;
};
